import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Button as Btn } from 'components';
import { Image, Dropdown, Popup, Grid } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './AdminUserList.css';
const cx = classNames.bind(styles);

class AdminUserFilter extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { handleInitFilter, filterClose, cancleCheck, executeFilter, paramData, filters, tempFilter, popupOpen, handlePopup } = this.props;

    // 로그인 실패 필터
    const loginFail = [
      { 1: defineMessages(formatMessage({ id: 'AdminUserList_6', defaultMessage: '잠김' })) },
      { 2: defineMessages(formatMessage({ id: 'AdminUserList_19', defaultMessage: '정상' })) }
    ];

    const loginFailFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'AdminUserList_17', defaultMessage: '로그인 실패' }))}
        />
        {loginFail.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.loginFailFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['loginFailArray'] &&
                      tempFilter['loginFailArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    // 유저활성화 필터
    const userActived = [
      { 0: defineMessages(formatMessage({ id: 'AdminUserList_22', defaultMessage: '비활성화' })) },
      { 1: defineMessages(formatMessage({ id: 'AdminUserList_21', defaultMessage: '활성화' })) }
    ];
    const userActivedFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header content={defineMessages(formatMessage({ id: 'AdminUserList_4', defaultMessage: '활성' }))} />
        {userActived.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.userActivedFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['userActivedArray'] &&
                      tempFilter['userActivedArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    // 삭제여부 필터
    const userEnabled = [
      { 0: defineMessages(formatMessage({ id: 'AdminUserList_23', defaultMessage: '삭제' })) },
      { 1: defineMessages(formatMessage({ id: 'AdminUserList_19', defaultMessage: '정상' })) }
    ];

    const userEnabledFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'AdminUserList_7', defaultMessage: '삭제 여부' }))}
        />
        {userEnabled.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.userEnabledFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['userEnabledArray'] &&
                      tempFilter['userEnabledArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    let loginFailArray =
      paramData.getIn(['filter', 'loginFailArray']) && paramData.getIn(['filter', 'loginFailArray']).toJS();

    let userActivedArray =
      paramData.getIn(['filter', 'userActivedArray']) && paramData.getIn(['filter', 'userActivedArray']).toJS();

    let userEnabledArray =
      paramData.getIn(['filter', 'userEnabledArray']) && paramData.getIn(['filter', 'userEnabledArray']).toJS();

    if (loginFailArray === undefined) {
      loginFailArray = [];
    }
    if (userActivedArray === undefined) {
      userActivedArray = [];
    }
    if (userEnabledArray === undefined) {
      userEnabledArray = [];
    }

    const totalArrayLength = loginFailArray.length + userActivedArray.length + userEnabledArray.length;

    let loginFailInfo = null;
    let userActivedInfo = null;
    let userEnabledinfo = null;

    if (loginFailArray.length > 0) {
      loginFailInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'AdminUserList_17', defaultMessage: '로그인 실패' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {loginFailArray.map((obj, index) => {
              const loginFailArray =
                paramData.getIn(['filter', 'loginFailArray']) && paramData.getIn(['filter', 'loginFailArray']).toJS();

              let templateStatus = '';
              if (loginFailArray[index] === '1') {
                templateStatus = defineMessages(formatMessage({ id: 'AdminUserList_6', defaultMessage: '잠김' }));
              } else if (loginFailArray[index] === '2') {
                templateStatus = defineMessages(formatMessage({ id: 'AdminUserList_19', defaultMessage: '정상' }));
              }

              const text =
                loginFailArray[loginFailArray.length - 1] !== loginFailArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }
    if (userActivedArray.length > 0) {
      userActivedInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'AdminUserList_4', defaultMessage: '활성' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {userActivedArray.map((obj, index) => {
              const userActivedArray =
                paramData.getIn(['filter', 'userActivedArray']) &&
                paramData.getIn(['filter', 'userActivedArray']).toJS();
              let templateStatus = '';
              if (userActivedArray[index] === '0') {
                templateStatus = defineMessages(formatMessage({ id: 'AdminUserList_22', defaultMessage: '비활성화' }));
              } else if (userActivedArray[index] === '1') {
                templateStatus = defineMessages(formatMessage({ id: 'AdminUserList_21', defaultMessage: '활성화' }));
              }

              const text =
                userActivedArray[userActivedArray.length - 1] !== userActivedArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }
    if (userEnabledArray.length > 0) {
      userEnabledinfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'AdminUserList_7', defaultMesssage: '삭제 여부' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {userEnabledArray.map((linkAttach, index) => {
              const userEnabledArray =
                paramData.getIn(['filter', 'userEnabledArray']) &&
                paramData.getIn(['filter', 'userEnabledArray']).toJS();
              let templateStatus = '';
              if (userEnabledArray[index] === '0') {
                templateStatus = defineMessages(formatMessage({ id: 'AdminUserList_23', defaultMessage: '삭제' }));
              } else if (userEnabledArray[index] === '1') {
                templateStatus = defineMessages(formatMessage({ id: 'AdminUserList_19', defaultMessage: '정상' }));
              }

              const text =
                userEnabledArray[userEnabledArray.length - 1] !== userEnabledArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }

    // 툴팁 정보
    const tooltipInfo = (
      <div className={cx('tooltip-wrapper')}>
        <div className={cx('arrow')} />
        {loginFailInfo}
        {userActivedInfo}
        {userEnabledinfo}
      </div>
    );

    return (
      <Tooltip
        classes={{
          tooltip: 'tooltip',
          tooltipOpen: totalArrayLength > 0 ? '' : 'close'
        }}
        title={tooltipInfo}
        placement="bottom">
        <div className={cx('target-dropdown-area', totalArrayLength > 0 ? 'target-dropdown-area-border' : '')}>
          <div className={cx('dropdown-arrow-area', 'table-filter-arrow')}>
            {totalArrayLength > 0 ? (
              <div className={cx('number-box')}>{totalArrayLength}</div>
            ) : (
                <Image className={cx('dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
              )}
          </div>
          <Popup
            className={cx('filter-popup')}
            trigger={
              <div className={cx('default-text', totalArrayLength > 0 ? 'filter-length' : '')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_35', defaultMessage: '필터' }))}
              </div>
            }
            open={popupOpen}
            onOpen={() => handlePopup(true)}
            onClose={() => { filterClose(), handlePopup(false) }}
            on="click"
            flowing
            position="bottom center">
            <Grid centered divided columns={3}>
              <Grid.Column textAlign="left">{loginFailFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{userActivedFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{userEnabledFilterOptions}</Grid.Column>
            </Grid>
            <Grid className={cx('bottom-options')}>
              <Grid.Column>
                <div className={cx('all-check-off')} onClick={handleInitFilter}>
                  {defineMessages(formatMessage({ id: 'Target_32', defaultMessage: '모든 필터 해제' }))}
                </div>
                <div className={cx('inline-block')}>
                  <Btn className={cx('button-border', 'button')} onClick={() => { cancleCheck(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취 소' }))}
                  </Btn>
                  <Btn
                    className={cx('button-brand', 'button')}
                    // loading={editOnProgress}
                    // disabled={disableSave && (editInvalid || editOnProgress)}
                    onClick={() => { executeFilter(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
                  </Btn>
                </div>
              </Grid.Column>
            </Grid>
          </Popup>
        </div>
      </Tooltip>
    );
  }
}

export default injectIntl(AdminUserFilter);



// WEBPACK FOOTER //
// ./src/script/components/admin/user/AdminUserFilter.js